import React from "react";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

function DeleteButtonFile({ onClick, fileName }) {
  const handleDelete = () => {
    if (
      window.confirm(
        `Are you sure you want to delete the file "${fileName}" permanently?`
      )
    ) {
      onClick();
    }
  };

  return (
    <div
      className="square-button-small delete-button-color"
      title="Delete"
      onClick={handleDelete}
    >
      <DeleteForeverIcon style={{ color: "white", fontSize: 20 }} />
    </div>
  );
}

export default DeleteButtonFile;
